// src/pages/support/components/Badge.jsx
import React from "react";

function Badge({ 
  children, 
  color = "#10b981", 
  bg = "rgba(16,185,129,0.12)", 
  border = "rgba(16,185,129,0.35)" 
}) {
  return (
    <span
      className="text-[11px] px-2 py-0.5 rounded-md"
      style={{ backgroundColor: bg, border: `1px solid ${border}`, color }}
    >
      {children}
    </span>
  );
}

export default Badge;